<div class="contacts">
  @if (!!phone) {
    <a href="tel:+{{ phone }}" class="contacts__link" (click)="onLinkClick($event)">
      <app-svg icon="phone-number"></app-svg>
    </a>
  }
  @if (!!email) {
    <a href="mailto:{{ email }}" class="contacts__link" (click)="onLinkClick($event)">
      <app-svg icon="email"></app-svg>
    </a>
  }
</div>
